window.Basket = {
	add: function (btn, lparams) {
		lparams = lparams || {};

		let type = $(btn).data('type');
		let id = $(btn).data('id');
		let title = $(btn).data('title');

		let params = {
			id: id,
			cnt: 1,
			_token: App.csrf,
		};

		$.extend(true, params, lparams);

		$.post('/basket/add_product', params, function (data) {
			Basket.showModalAdded(type, title);

			Basket.updateGlobalProductsCounter(data.basket_cnt_products);

			$('.btn-toggle-composition[data-composition_id="' + lparams.composition_id + '"]').data('in_basket', 1);
		});
	},

	updateGlobalProductsCounter: function (cnt) {
		$('.basket-p-counts').data('cnt', cnt).html(cnt).show();
	},

	delProduct: function ($self) {
		let params = {
			pivot_id: $self.data('pivot_id'),
			_token: App.csrf
		};

		$.post($self.data('route'), params, function (data) {
			$self.closest('.item').remove();

			Basket.sumProducts(data.basket.sum_products);
			Basket.sumTotal(data.basket.sum);
			Basket.cntProducts(data.basket_cnt_products);
		});
	},

	changeProduct: function ($self) {
		let cnt = $self.val(),
			params = {
				_token: App.csrf,
				products: [],
				promocode: $('.cart-promocode [name=promocode]').val()
			};

		$('.table-products .item').each(function (i, item) {
			params.products.push({
				pivot_id: $(item).data('pivot_id'),
				cnt: $(item).find('[name=item_quantity]').val(),
			});
		});

		$.post($self.data('route'), params, function (data) {
			if (!data.error) {
				for (let i in data.basket_products_sums) {
					let item = data.basket_products_sums[i];

					$self.closest('.item[data-pivot_id="' + item.id + '"]').find('.price single-price').text(item.price_formatted[0]);

					$self.closest('.item[data-pivot_id="' + item.id + '"]').find('.total-price span').text(item.price_formatted[1]);
				}

				Basket.sumTotal(data.basket.sum);
				Basket.sumProducts(data.basket.sum_products);
				Basket.sumPromocode(data.basket.sum_promocode);
			}
		});
	},

	cntProducts: function (cnt) {
		Basket.updateGlobalProductsCounter(cnt);

		if (cnt) {
			$('.products-count-title').html('В вашей корзине <span class="cnt">' + cnt + '</span> ' + wordform_products_count(cnt));
		} else {
			$('.products-count-title').html('Корзина пуста');
			$('.table-products').slideUp();
			$('.cart-footer').slideUp();
		}
	},

	showModalAdded: function (type, title) {
		let $modal = $("#modal-product-added");

		$modal.find('.product-type').html(type);

		if (title) title = '"' + title + '"';

		$modal.find('.product-added').html(title);

		$modal.modal('show');
	},

	sumTotal: function (sum) {
		$('.cart-details .sum-all').html(output_numbers(sum));
	},

	sumProducts: function (sum) {
		$('.cart-details .sum-products').html(output_numbers(sum));
	},

	sumPromocode: function (sum) {
		$('.cart-details .sum-promocode').html(output_numbers(sum));
	},

	choiceToy: function ($self) {
		let $tab_toy = $self.closest('.tab-toy'),
			$toy = $tab_toy.find('figure');

		$toy.removeClass('checked').find('a').text('Выбрать');
		$self.closest('figure').addClass('checked');

		$self.removeClass('choiceToy').addClass('dropToy').text('Убрать');

		this.getToyPrice($tab_toy);
	},

	dropToy: function ($self) {
		$self.removeClass('dropToy').addClass('choiceToy').text('Выбрать');
		$self.closest('figure').removeClass('checked');
		$('.product-content').find('.price .sum-toy').html('');
	},

	disabled: function ($self, compositionId, self_btn_add = true) {
		if (self_btn_add) {
			$self.addClass('disabled').attr('disabled', 'disabled');
		} else {
			$self.closest('.product-info').find('button.btn-add-to-basket').attr('disabled', 'disabled');
		}

		$('.tab-toy[data-composition_id=' + compositionId + ']').find('.owlToysInGifts').addClass('disabled');
	},

	getToyPrice: function ($tab_toy) {
		let price = $tab_toy.find('.checked').data('price') || 0;
		if (price > 0) {
			$('.product-content').find('.price .sum-toy').html(' + <span class="fw-900">' + price + '</span>');
		} else {
			$('.product-content').find('.price .sum-toy').html('');
		}
	},

	getCount: function ($input) {
		let cnt = parseInt($input.val()),
			max = parseInt($input.attr('max'));

		if (cnt < 1 || cnt === '' || cnt === '.') {
			cnt = 1;
		}

		if (cnt > max) {
			cnt = max;
		}

		$input.val(cnt);

		return cnt;
	}
};

$(document).ready(function () {
	Basket.getToyPrice($('[data-composition_id=1]'));

	$(document).on('change', '.in-cnt', function () {
		Basket.getCount($(this));

		return false;
	});

	$(document).on('click', '.btn-add-to-basket', function () {
		let $composition = $('.btn-toggle-composition.active'),
			stock = parseInt($composition.data('stock')),
			compositionId = $composition.data('composition_id'),
			toyId = $('[data-composition_id=' + compositionId + ']').find('.owlToysInGifts').find('.checked').data('id') || 0;

		let cnt = Basket.getCount($(this).closest('.add-to-cart').find('.in-cnt'));

		// Добавляем подарок в корзину вместе с наполнением и игрушкой если она выбрана
		Basket.add($(this), {
			cnt: cnt,
			composition_id: compositionId,
			toy_id: toyId,
		});

		stock = stock - cnt;
		$('.btn-toggle-composition').attr('data-stock', stock);

		// Блокируем кнопку и игрушки к этому подарку
		Basket.disabled($(this), compositionId);

		return false;
	});

	$(document).on('click', '.btn-add-figure-to-basket', function () {
		let chocolate_type_id = $(this).closest('.add-to-cart').find('[name=chocolate_type_id]').val();

		let cnt = Basket.getCount($(this).closest('.add-to-cart').find('.in-cnt'));

		Basket.add($(this), {
			cnt: cnt,
			chocolate_type_id: chocolate_type_id,
		});

		let $select = $('select[name=chocolate_type_id]');
		$select.find('option[value="' + chocolate_type_id + '"]').attr('data-inbasket', 1);

		$select.trigger('change');

		return false;
	});

	$('.product-info [name=chocolate_type_id]').change(function () {
		let $option = $(this).find('option:selected');
		let inBasket = $option.attr('data-inbasket') == 1;
		let $btn = $(this).closest('.product-info').find('.btn-add-figure-to-basket');
		let price = $option.attr('data-price');

		if (inBasket) {
			$btn.addClass('disabled').attr('disabled', 'disabled').html('В корзине');
		} else {
			$btn.removeClass('disabled').removeAttr('disabled').html('В корзину');
		}

		$(this).closest('.product-info').find('.price .sum').html(output_numbers(price));
	});

	$(document).on('click', '.btn-toggle-composition', function () {
		let $composition = $(this),
			composition_id = $composition.data('composition_id'),
			$tab_toy = $('.tab-toy[data-composition_id=' + composition_id + ']'),
			$container = $composition.closest('.compositions-area'),
			stock = $composition.data('stock'),
			$btn_print = $('.btn-print-product');

		let print_route = $btn_print.data('route');
		$btn_print.attr('href', print_route + '?composition_id=' + composition_id);

		// Переключаем вкладки с игрушками
		$('.tab-toy').removeClass('active');
		$tab_toy.addClass('active');

		// Переключаем кнопки с наполнением
		$container.find('.btn-toggle-composition').removeClass('active');
		$(this).addClass('active');

		// Переключаем вкалдки с наполнением
		$('#composition-tabs .composition-title').text($.trim($(this).text()));
		$('#composition-tabs .col-fitem').hide();
		$('#composition-tabs .col-fitem[data-composition_id="' + composition_id + '"]').show();

		// Блокируем или деблокируем кнопку "Добавить в корзину", если этот подарок добавлен в корзину, а так же игрушки
		if ($(this).data('in_basket')) {
			$tab_toy.find('.owlToysInGifts').addClass('disabled');
			$(this).closest('.product-content').find('.btn-add-to-basket').addClass('disabled').attr('disabled', 'disabled');
		} else {
			$tab_toy.find('.owlToysInGifts').removeClass('disabled');
			$(this).closest('.product-content').find('.btn-add-to-basket').removeClass('disabled').removeAttr('disabled');
		}

		// Меняем ценник
		let price = parseInt($(this).data('price')),
			discount = parseInt($(this).data('discount'));

		$(this).closest('.product-content').find('.old-price .sum').html(price);

		if (discount > 0) price = discount;

		$(this).closest('.product-content').find('.price .sum').html(price);

		// Добавляем ценник игрушки в данном наполнении
		Basket.getToyPrice($tab_toy);

		if (stock === 0) {
			// Блокируем кнопку и игрушки к этому подарку
			Basket.disabled($composition, composition_id, false);
		}
	});

	$(document).on('click', '.choiceToy', function () {
		Basket.choiceToy($(this));

		return false;
	});

	$(document).on('click', '.dropToy', function () {
		Basket.dropToy($(this));

		return false;
	});

	$(document).on('click', '.btn-del-product', function () {
		Basket.delProduct($(this));

		return false;
	});

	$(document).on('change', "input[name=item_quantity]", function () {
		let $self = $(this),
			$counter = $self.closest('.counter-area'),
			cnt = parseInt($self.val()),
			min = parseInt($self.attr('min')),
			max = parseInt($self.attr('max'));

		if (cnt <= min) {
			$self.val(min);
			$counter.find('[data-type="minus"]').attr('disabled', true)
		} else {
			$counter.find('[data-type="minus"]').attr('disabled', false)
		}

		if (cnt >= max) {
			$self.val(max);
			$counter.find('[data-type="plus"]').attr('disabled', true)
		} else {
			$counter.find('[data-type="plus"]').attr('disabled', false)
		}

		Basket.changeProduct($(this));

		return false;
	});

	$(document).on('click', '.counter-area--button', function () {
		let $self = $(this),
			$counter = $self.closest('.counter-area'),
			$inputCnt = $counter.find('[name="item_quantity"]'),
			type = $self.data('type'),
			cnt = parseInt($inputCnt.val()),
			min = parseInt($inputCnt.attr('min')),
			max = parseInt($inputCnt.attr('max'));

		if (type === 'minus') {
			if (cnt > min) {
				cnt--;
			} else {
				cnt = min
			}
		}

		if (type === 'plus') {
			if (cnt < max) {
				cnt++;
			} else {
				cnt = max
			}
		}

		$inputCnt.val(cnt)

		if (cnt === min) {
			$self.attr('disabled', true)
		} else {
			$counter.find('[data-type="minus"]').removeAttr('disabled')
		}

		if (cnt === max) {
			$self.attr('disabled', true)
		} else {
			$counter.find('[data-type="plus"]').removeAttr('disabled')
		}

		$inputCnt.trigger('change')

		return false;
	});

	$(document).on('input change', '.cart-promocode [name=promocode]', function () {
		let params = {
				code: $(this).val()
			},
			$container = $(this).closest('.cart-promocode');

		if (!params.code) {
			$container.find('.success-msg, .error-msg').hide();
			return;
		}

		$.get('/basket/check_promocode', params, function (data) {
			$container.find('.success-msg, .error-msg').hide();

			if (data.error) {
				$container.find('.error-msg').html(data.msg).show();
			} else {
				$container.find('.success-msg .discount').html(data.discount).show();
				$container.find('.success-msg').show();
				$container.find('.set-promocode').show();
			}
		});

		return false;
	});

	$(document).on('click', '.cart-promocode .btn-clear-promocode', function () {
		let $form = $("#form-cart");
		$('.cart-promocode [name=promocode]').val('');
		$form.trigger('submit');
	});

	$(document).on('click', '.cart-promocode .btn-set-promocode', function () {
		let $form = $("#form-cart");
		$form.trigger('submit');
	});
});
